angular.module("vgresiduos").controller("PlansListCtrl", [
	"$rootScope",
	function ($rootScope) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, `master/planos`);
		};
	}
]);
